<template>
  <section>
    <div class="text-center mb-8 text-static-info-hi">
      <IconSparklesFilled class="inline" size="12" />
      <span class="caption ml-2">
        {{ i18n(translations.promptSuggestionsTitle) }}
      </span>
    </div>
    <div
      class="flex flex-col gap-12 bg-static-info-low rounded-[22px] p-12 items-end"
    >
      <RevButtonBase
        v-for="(text, index) in suggestions"
        :key="index"
        class="bg-static-info-mid text-static-info-hi p-12 rounded-lg !rounded-br-sm"
        @click="$emit('click', text)"
      >
        {{ text }}
      </RevButtonBase>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { IconSparklesFilled } from '@ds/icons/IconSparklesFilled'

import translations from '../ShoppingAssistant.translations'

defineProps<{ suggestions: string[] }>()

defineEmits(['click'])

const i18n = useI18n()
</script>
